import { render, staticRenderFns } from "./WriteInformation.vue?vue&type=template&id=954f4df6&"
import script from "./WriteInformation.vue?vue&type=script&lang=js&"
export * from "./WriteInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports